import { createActions, createReducer, Types as ReduxSauceTypes } from 'reduxsauce';
import INITIAL_STATE from './globals-model.js';

const defaultHandler = (state = INITIAL_STATE) => state;

const setLoading = (state, { isLoading }) => ({
  ...state,
  isLoading: isLoading,
});

export const { Types, Creators } = createActions({
  // Management
  globalsSetLoading: ['isLoading'],
});

export default createReducer(INITIAL_STATE, {
  // Management
  [ReduxSauceTypes.DEFAULT]: defaultHandler,
  [Types.GLOBALS_SET_LOADING]: setLoading,
});
